<div
  class="text-image flex-column-reverse flex-md-row row gx-4"
  [class.invert]="inverse()"
>
  <div
    class="col-md-6 col-sm-12 pt-2 pt-md-0 z-1"
    [ngClass]="'text-image__container--theme-' + theme"
  >
    <h2 class="text-image__heading" *scText="title()"></h2>
    @if (showContent() && content(); as content) {
      <wl-rich-text-wrapper [field]="content">
        <div class="text-image__text mb-2"></div>
      </wl-rich-text-wrapper>
    }
    <div class="text-image__button-container d-flex flex-column flex-md-row">
      <ng-content />
      @if (showPrimaryButton() && primaryButton(); as primaryButton) {
        <crnt-button-alt
          class="flex-grow-1 flex-md-grow-0"
          variant="secondary"
          [inverted]="buttonsShouldBeInverted()"
          wlTrackLink
          [trackLinkInfo]="{
            rendering: { componentName: 'TextImageComponent' },
            field: primaryButton.value?.text || '',
            eventType: 'button-click',
            type: 'button',
          }"
        >
          <a *wlGenericLink="primaryButton"></a>
        </crnt-button-alt>
      }
      @if (showSecondaryButton() && secondaryButton(); as secondaryButton) {
        <crnt-button-alt
          class="flex-grow-1 flex-md-grow-0"
          variant="tertiary"
          [inverted]="buttonsShouldBeInverted()"
          wlTrackLink
          [trackLinkInfo]="{
            rendering: { componentName: 'TextImageComponent' },
            field: secondaryButton.value?.text || '',
            eventType: 'button-click',
            type: 'button',
          }"
        >
          <a *wlGenericLink="secondaryButton"></a>
        </crnt-button-alt>
      }
    </div>
    @if (showMicrocopy() && microcopy(); as microcopy) {
      <p class="mt-2" *scText="microcopy"></p>
    }
  </div>
  <div
    class="col-md-6 col-sm-12 d-flex justify-content-center position-relative"
  >
    @if (isEnergieDirect()) {
      <div class="text-image__background-container d-flex flex-column">
        <wl-background-pattern />
        <wl-background-pattern />
        <wl-background-pattern />
      </div>
    }
    <picture>
      <img
        *scImage="image()"
        class="text-image__image position-relative w-100 z-1"
      />
    </picture>
  </div>
</div>
